import type { ComponentProps, ReactNode } from 'react'
import { cn } from '../lib/cn'
import { Media } from './media'
export function Avatar({
  fallback,
  size = 'md',
  className,
  ...props
}: ComponentProps<typeof Media> & { fallback: ReactNode; size?: 'sm' | 'md' | 'lg' }) {
  return (
    <Media
      {...props}
      aspect="square"
      fallback={fallback}
      className={cn(
        'shrink-0 rounded-full bg-accent font-semibold text-accent-foreground [&>div]:text-accent-foreground',
        size === 'sm' ? 'size-8 text-xs' : size === 'lg' ? 'size-14 text-lg' : 'size-10 text-sm',
        className,
      )}
    />
  )
}
